(function () {
  'use strict';
  var quoteBlock = document.querySelector('[data-quote-block]');
  var quoteForm = quoteBlock && quoteBlock.querySelector('form.quote-form');
  if (quoteForm) {
    quoteForm.addEventListener('submit', function (event) {
      var endpoint = quoteBlock.getAttribute('data-quote-endpoint');
      if (!endpoint) return;
      event.preventDefault();
      var button = quoteForm.querySelector('[type="submit"]');
      var status = quoteForm.querySelector('[data-quote-status]');
      if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
      if (status) status.textContent = 'Saving your quotation request…';
      fetch(endpoint, { method: 'POST', body: new FormData(quoteForm), headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (response) { if (!response.ok) throw new Error('Quote service failed'); return response.json(); })
        .then(function (result) {
          if (!result || result.ok !== true || !result.reference) throw new Error('Invalid quote response');
          if (status) status.textContent = 'Quotation request ' + result.reference + ' has been saved.';
          return fetch(((window.Shopify && window.Shopify.routes.root) || '/') + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
        })
        .catch(function () { if (status) status.textContent = 'The quotation could not be saved. Your specification has not been cleared. Please try again.'; })
        .finally(function () { if (button) { button.disabled = false; button.removeAttribute('aria-busy'); } });
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-save-project]');
    if (!trigger) return;
    var endpoint = trigger.getAttribute('data-endpoint');
    var status = trigger.parentElement.querySelector('[data-project-status]');
    if (!endpoint) return;
    trigger.disabled = true;
    if (status) status.textContent = 'Saving project…';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Cart read failed'); return response.json(); })
      .then(function (cart) { return fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ cart: cart }) }); })
      .then(function (response) { if (!response.ok) throw new Error('Project save failed'); return response.json(); })
      .then(function (result) { if (!result || !result.reference) throw new Error('Invalid project response'); if (status) status.textContent = 'Project ' + result.reference + ' has been saved.'; })
      .catch(function () { if (status) status.textContent = 'The project could not be saved. Please try again.'; })
      .finally(function () { trigger.disabled = false; });
  });
})();
